import { createSelector } from '@ngrx/store';

import { AppState } from 'store/root-reducer';

import * as userPreference from 'store/actions/user-preference.actions';

import { TablesPreference, TablePreferenceType } from 'modules/shared/models/table-preference.models';

export interface State {
  tablesPreference: TablesPreference;
}

const initialState: State = {
  tablesPreference: {}
};

export function reducer(state: State = initialState, action: userPreference.UserPreferenceActions): State {
  switch (action.type) {
    case userPreference.UserPreferenceActionTypes.SET_PAGINATION_PREFERENCE: {
      return {
        ...state,
        tablesPreference: {
          ...state.tablesPreference,
          [action.payload.tableName]: {
            ...state.tablesPreference[action.payload.tableName],
            [TablePreferenceType.PAGE_SIZE]: action.payload.pageSize
          }
        }
      };
    }
    case userPreference.UserPreferenceActionTypes.SET_SORT_PREFERENCE: {
      return {
        ...state,
        tablesPreference: {
          ...state.tablesPreference,
          [action.payload.tableName]: {
            ...state.tablesPreference[action.payload.tableName],
            [TablePreferenceType.SORT]: action.payload.sort
          }
        }
      };
    }
    default: {
      return state;
    }
  }
}

const userPreferenceSelector = (state: AppState) => state.userPreference;
export const Selectors = {
  getTablesPreference: createSelector(userPreferenceSelector, (state: State) => state.tablesPreference),
};
